var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 431 293",
    width: 431,
    height: 293,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "faq-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #aaaaaa } \n\t\t.s2 { fill: #e0e0e0 } \n\t\t.s3 { fill: #d9d9d9 } \n\t\t.s4 { fill: #2b2b2b } \n\t\t.s5 { fill: #3d3d3d } \n\t\t.s6 { fill: #ffcba8 } \n\t\t.s7 { fill: #e28b6d } \n\t\t.s8 { fill: #fc8019 } \n\t\t.s9 { fill: #e0e3eb } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m418.5 186.4c-7-16-20.6-29.4-36.8-36-17-6.8-36.4-4.3-54.2-6.6-15.5-2-26.7-8.9-36-21.2-8.8-11.8-16.8-24.9-31.3-30.3-11.4-4.3-24.5-3.1-35.8 1.3-21 8.3-36.9 25.9-50.2 43.4-12.2 16-22.1 33.5-44.6 34.1-22.6 0.6-44.1-12.3-66.8-8.9-30 4.5-54.9 29.5-60.2 59.2-4.9 27.9 7.4 54.9 28.6 70.8h363.6c26.6-28.3 40.6-67.3 23.7-105.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m89.8 292.2h1c7-7.6 12.4-16.9 15.9-27.2 5.6-16.6 5.4-34.1-0.7-49.2-3-7.6-7.4-14.7-11.7-21.5-4.3-7-8.8-14.2-11.8-21.9-1.2-3.2-2.2-6.6-2.7-10.1q-0.4-0.1-0.8-0.1c0.6 3.6 1.5 7.1 2.8 10.4 3.1 7.8 7.6 15 11.9 22 4.2 6.9 8.6 14 11.6 21.5 6 14.9 6.2 32.2 0.7 48.7-3.5 10.4-9.1 19.8-16.2 27.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m198.5 45.7c6.4 6.5 9.2 17.5 5.7 27.6-3.4 9.8-10.8 17.9-19.8 23.1-7.2 4.2-16.6 6.5-23.7 2.1-5.3-3.3-8-9.7-8.2-16-0.1-6.2 2-12.3 4.5-17.9 3.7-8 8.6-15.8 15.9-20.6 10.1-6.7 19.5-4.6 25.6 1.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m388 52.2q-3.9-13-13.8-24-9.9-10.9-27.1-18.1-17.1-7.1-43.5-7.1-21 0-42.8 5.6-21.9 5.7-38 16.2l14 38.4-7.5 6 10.8 3.2q16.1-8.4 29.3-12.2 13.2-3.8 28.1-3.8 14.8 0 22.4 7.2 7.7 7.2 7.7 17.3 0 12.2-7.9 21.7-7.8 9.4-17.3 19.1-6.6 6.7-12.8 13.9-6.2 7.2-10.9 15.4-4.8 8.2-7.6 17.7-2.9 9.5-2.9 21.2 0 3.8 0.2 9.1 0 1 0.1 1.9h-10.3l11.2 7.6h54.5q-0.5-2.6-0.5-5.9 0-3.4 0-5.1 0-7.1 2.9-14.1 2.9-6.9 7.2-13.3 4.4-6.3 9.7-12 5.4-5.6 10.4-10.7 6.5-6.7 13.6-14.3 7-7.6 12.3-16 5.4-8.4 8.9-18.3 3.5-9.9 3.5-21.7 0-11.8-3.9-24.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m285.9 53.8q-14.7 0-27.7 3.6-13 3.7-28.9 11.8l-17.1-46q15.8-10.2 37.5-15.7 21.6-5.5 42.4-5.5 26 0 42.9 6.9 17 6.9 26.7 17.6 9.8 10.6 13.7 23.2 3.9 12.6 3.9 24 0 11.4-3.5 21-3.5 9.6-8.8 17.8-5.3 8.1-12.2 15.4-6.9 7.4-13.4 13.9-4.9 4.9-10.2 10.4-5.3 5.5-9.6 11.6-4.3 6.1-7.1 12.8-2.9 6.8-2.9 13.7 0 1.6 0 4.9 0 3.3 0.4 5.7h-53.8q-0.8-4.1-1-9.2-0.2-5.1-0.2-8.7 0-11.4 2.8-20.6 2.9-9.2 7.6-17.1 4.7-8 10.8-14.9 6.1-6.9 12.6-13.5 9.4-9.3 17.1-18.5 7.8-9.2 7.8-21 0-9.8-7.6-16.7-7.5-6.9-22.2-6.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m327.6 261.3q0 14.7-9.6 22.7-9.5 8.1-21.5 8.1-12 0-21.6-8.1-9.5-8-9.5-22.7 0-14.7 9.5-22.7c9.8-8.3 24.3-10.1 35.7-4.3 10.2 5.1 17 15.6 17 27z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m316.9 261.3q0 14.7-9.5 22.7-9.5 8.1-21.6 8.1-12 0-21.5-8.1-9.5-8-9.5-22.7 0-14.7 9.5-22.7 9.5-8 21.5-8 12.1 0 21.6 8 9.5 8 9.5 22.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m111.2 70.4c0.8-4.1-1.9-8.1-6.1-8.9-4.1-0.8-8.1 2-8.9 6.1-0.8 4.2 2 8.2 6.1 8.9 4.2 0.8 8.2-1.9 8.9-6.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m114.9 84.8c0.4-2.3-1.1-4.6-3.5-5-2.3-0.5-4.6 1.1-5 3.4-0.5 2.4 1.1 4.6 3.4 5 2.4 0.5 4.7-1.1 5.1-3.4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m106.1 51.8c11.8-11.7 11.8-30.8 0-42.6-11.7-11.7-30.8-11.7-42.6 0-11.7 11.8-11.7 30.9 0 42.6 11.8 11.8 30.9 11.8 42.6 0z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m73.3 34.3c2.1 0 3.8-1.7 3.8-3.8 0-2.1-1.7-3.8-3.8-3.8-2.1 0-3.8 1.7-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m84.8 34.3c2.1 0 3.8-1.7 3.8-3.8 0-2.1-1.7-3.8-3.8-3.8-2.1 0-3.7 1.7-3.7 3.8 0 2.1 1.6 3.8 3.7 3.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m96.4 34.3c2.1 0 3.8-1.7 3.8-3.8 0-2.1-1.7-3.8-3.8-3.8-2.1 0-3.8 1.7-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m63.3 277l2.8 10.8c0.7 2.9 3.5 4.8 6.5 4.6 9.2-0.7 28.4-2.9 39.4-11l-3.2-15.7c-15.1-0.8-29.2 0-41.5 4.2-3 1-4.8 4.1-4 7.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m80.9 285.6c-0.2 0-0.3-0.1-0.3-0.2l-3.8-13.6c-0.1-0.2 0-0.4 0.2-0.4 0.2-0.1 0.4 0 0.5 0.2l3.8 13.6c0 0.2-0.1 0.4-0.3 0.4q0 0-0.1 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m89.1 283.8c-0.2 0-0.3-0.1-0.4-0.3l-3.8-13.5c0-0.2 0.1-0.4 0.3-0.4 0.2-0.1 0.4 0 0.4 0.2l3.8 13.5c0.1 0.2 0 0.4-0.2 0.5q-0.1 0-0.1 0z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m98.6 218.4l-35.2 10.4 26.1 35.8 37.5 2.9 51.7-21.8-19.7-29.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m141.9 223.3c77.2-22.8 89.6 45.4-30.9 57.8-4.2-4.8-9.2-13.1-11.2-20l63.7-29.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m145.2 272.2c-3.6-1.1-7.1-3.4-7.1-3.4l-12.4 3.9 2.8 13.5 12.9 2.6c4-7.2 4.2-13.1 3.8-16.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m100.1 261.6l-0.5-1c13.2-7.7 47.2-26.2 76.2-31.7l0.2 1.1c-28.8 5.4-62.7 23.9-75.9 31.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m98.6 218.4c-71.9-13.7-90.5 55.4 29.9 67.8 4.3-4.8 7.6-10.5 9.6-17.4-18.5-12.4-39.2-24.2-61.9-35.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m137.8 269.3c-3.4-2.2-7-4.5-10.7-7-19-12.2-40.4-26-58.7-33.9l0.5-1c18.3 7.9 39.8 21.8 58.7 34 3.8 2.5 7.4 4.8 10.8 6.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m45.8 252.6l-0.9-0.5c2.7-4.9 7-8.2 12.8-9.8l0.3 1c-5.6 1.6-9.6 4.6-12.2 9.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m195.8 248.4c-2.6-4.6-6.6-7.7-12.2-9.2l0.3-1.1c5.9 1.6 10.2 4.9 12.9 9.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m121.8 285.6l-0.8-0.8c5.8-6.1 9.3-12.6 10.8-19.8l1.1 0.2c-1.6 7.4-5.2 14.1-11.1 20.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m181 268.2c-9.2-5.7-27 4.2-31.5 4.6-1.3 0.2-2.8-0.1-4.3-0.6 0.4 3.5 0.1 9.4-3.8 16.6l2.2 0.4c0 0 15.1 5.6 31.2 2.4 14.8-3 13.4-18.9 6.2-23.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m168.5 286.8q-0.1 0-0.2 0c-0.1-0.1-0.3-0.3-0.2-0.5 1.1-3.4 1.6-10.2-1.6-14.8-0.1-0.2-0.1-0.4 0.1-0.5 0.2-0.1 0.4-0.1 0.5 0.1 3.3 4.8 2.8 11.9 1.7 15.5 0 0.1-0.2 0.2-0.3 0.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m161.2 288.2q0 0-0.1 0c-0.2-0.1-0.3-0.3-0.2-0.5 1.1-3.5 1.6-10.3-1.6-14.8-0.1-0.2-0.1-0.4 0.1-0.5 0.2-0.2 0.4-0.1 0.5 0 3.3 4.8 2.8 11.9 1.7 15.5-0.1 0.2-0.2 0.3-0.4 0.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m85.8 129.3c0 0 18.1-15.4 17.5-18.3-0.5-2.1-5.6 1-5.6 1 0 0 7.1-8.6 6.8-9.6-0.7-1.8-5.6 1.6-5.6 1.6 0 0 3.3-4.8 1.7-5.6-1.6-0.8-5.1 2.2-5.1 2.2 0 0 2-2.7 1.1-3.4-1-0.7-5.1 2.2-5.1 2.2 0 0 1.5-3.4-1.7-2.1-3.2 1.3-25.3 21.6-25.3 21.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m93.2 111.1q-0.1 0-0.2-0.1c-3.1-2.9-4.5-3.6-7.9-4.6-0.2-0.1-0.3-0.3-0.3-0.5 0.1-0.2 0.3-0.3 0.5-0.2 3.6 1.1 5 1.8 8.2 4.7 0.1 0.2 0.1 0.4 0 0.5q-0.1 0.2-0.3 0.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m87.8 119.4q0 0-0.1 0c-0.2 0-0.3-0.2-0.3-0.4 0.4-2.6 1.2-4.1 2.5-4.9q1.6-0.9 4.2 0.2c0.2 0.1 0.3 0.3 0.2 0.5 0 0.2-0.3 0.3-0.4 0.2q-2.3-1-3.7-0.2-1.6 0.9-2 4.3c-0.1 0.2-0.2 0.3-0.4 0.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m86.9 104q-0.1 0-0.2-0.1c-0.2-0.1-0.2-0.4 0-0.5l4.5-4.3c0.2-0.1 0.4-0.1 0.5 0 0.2 0.2 0.2 0.4 0 0.5l-4.5 4.3q-0.1 0.1-0.3 0.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m91.1 105.5q-0.1 0-0.2-0.1c-0.2-0.2-0.2-0.4 0-0.5l4.3-4.6c0.2-0.1 0.4-0.1 0.6 0 0.1 0.2 0.1 0.4 0 0.5l-4.4 4.6q-0.1 0.1-0.3 0.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m95.4 108q-0.1 0-0.2-0.1c-0.2-0.1-0.2-0.3 0-0.5l3.4-3.6c0.1-0.2 0.4-0.2 0.5-0.1 0.2 0.2 0.2 0.4 0 0.6l-3.4 3.6q-0.1 0.1-0.3 0.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m154.2 232.3l-66.2 2.5-7.3-60.3c0 0 22.2-21 30.7-28.8l14.4-0.7c44.6 20.3 37.3 45.6 28.4 87.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m125.8 145c0 0 51.1 4.4 67.2 39.4 15.7 34.2-49 46.4-49 46.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m67.4 152.5l21.1-25.7-19.7-11.9c-8.3 5.7-24.2 18.6-37.7 33.3-2.9 3.3-5.3 7.1-6.4 11.2-1 3.6-1.2 7.1-0.7 10.5 1.5 9 8.6 15.9 18 17 8 1 38.7-1.4 63.6-8.8l7.3-28.2c-3.8-2.1-31.7-2.5-45.5 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.8
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m168.4 158.9q0.2 0 0.3-0.1-0.3-0.2-0.7-0.4c-3.7 0.9-7.6 1.8-11.4 2.2-2.3 0.3-9.9 0.8-12.1-4.3-1.1-2.5-0.3-5.4 1-7.3q-0.3-0.1-0.6-0.2c-1.3 2.1-2.1 5-0.9 7.7 2.3 5.5 10.3 4.9 12.7 4.7 3.9-0.5 7.9-1.4 11.7-2.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m192.2 198.4c-2.4-1-4.9-2-7.6-1.7-4.6 0.4-8.6 5-8.8 10.2-0.2 3.6 1.2 7.3 3.7 10.6q0.3-0.2 0.5-0.3c-2.5-3.2-3.8-6.8-3.7-10.2 0.2-5 4-9.4 8.4-9.8 2.5-0.2 4.9 0.7 7.3 1.7q1.4 0.5 2.8 0.9 0-0.2 0.1-0.5-1.4-0.4-2.7-0.9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m63.3 180.9c-3.2-2.6-8.1-3.3-13.6-1.9-4.8 1.2-9 3.7-11.8 7q0.2 0.1 0.5 0.2c2.8-3.1 6.8-5.5 11.5-6.7 5.3-1.4 10-0.7 13.1 1.8 1.4 1.2 2.5 2.8 3.2 4.5q0.3-0.1 0.6-0.1c-0.8-1.8-1.9-3.5-3.5-4.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m34.5 144.6c6-1.4 11.8-3.5 17.2-6.6 2-1.2 4.3-2.7 5.9-4.9 1.8-2.3 2.3-5.1 1.6-7.4-0.3-0.9-0.9-1.7-1.5-2.3q-0.2 0.1-0.4 0.3c0.6 0.6 1.1 1.3 1.3 2.2 0.7 2.1 0.2 4.7-1.4 6.9-1.6 2.1-3.8 3.6-5.8 4.7-5.1 2.9-10.5 4.9-16.2 6.4q-0.3 0.4-0.7 0.7z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m130.5 131.6v0.9l-0.2 14.6v1.5c0 2.5-1.1 4.7-2.7 6.4-1.6 1.6-3.8 2.6-6.3 2.6-5 0-9.1-4-9.1-9l-0.2-17.9z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m130.4 132.5l-0.1 14.6c-8.1-3.3-11.4-12.1-11.4-12.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m133.6 107.1c2.9 3.5 11.4 23.2 2.8 29.9-9.6 7.6-24.3-4.8-24.3-4.8l-2-23 12.8-3.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m103.6 105.9c0 0-28.2 14.7-5.2 57.2 3 5.5 9.5 7.9 15.1 5.2 6.1-2.8 8.3-10.2 5.1-16-3.8-6.7-7.4-15.3-5.9-21.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m111.7 118.3c3-3 3-7.9 0-10.8-3-3-7.8-3-10.8 0-3 2.9-3 7.8 0 10.8 3 3 7.8 3 10.8 0z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m115.7 122.1c-0.8-4.8-1.3-8.1 3.5-10.5 0 0 17 3 20.2-3.4 3.3-6.4-1.7-16.5-12-9.5-26.5-5.1-30.1 19.6-22 27.9l7.9-1.2c1.6-0.2 2.7-1.8 2.4-3.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m128.9 123.2c0.6 0 1.1-0.5 1.1-1.1 0-0.7-0.5-1.2-1.1-1.2-0.7 0-1.2 0.5-1.2 1.2 0 0.6 0.5 1.1 1.2 1.1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m136.5 119.4c0.6 0 1.1-0.5 1.1-1.1 0-0.6-0.5-1.1-1.1-1.1-0.6 0-1.1 0.5-1.1 1.1 0 0.6 0.5 1.1 1.1 1.1z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m135.7 125.5q-0.1 0-0.2 0c-0.1-0.2-0.1-0.4 0-0.5 0.5-0.5 0.9-1.1 0.7-1.6-0.2-0.5-1.1-0.8-1.5-0.8-0.9 0-1.3-1.6-1.4-1.9-0.1-0.1 0-0.3 0.2-0.4 0.2 0 0.4 0.1 0.4 0.3 0.2 0.6 0.5 1.4 0.8 1.4 0.4 0 1.7 0.2 2.1 1.1q0.4 1-0.8 2.3-0.1 0.1-0.3 0.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m135.8 129.8q-0.1 0-0.2 0c-2.1-1.5-4.3-0.3-4.3-0.2-0.1 0-0.3 0-0.4-0.2-0.1-0.1-0.1-0.3 0.1-0.4 0.1-0.1 2.5-1.4 5 0.2 0.1 0.1 0.2 0.3 0.1 0.5q-0.1 0.1-0.3 0.1z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m128.4 117.2c0.6 1.2-0.5 1.4-1.8 2.1-1.3 0.7-2.7 1-3 0.4-0.3-0.6 0.5-1.6 1.8-2.3 1.4-0.7 2.5-1.2 3-0.2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m133.2 115c0.2 1.1 1 0.6 2.2 0.3 1.2-0.3 2.1-0.9 2-1.4-0.1-0.5-1.2-0.7-2.4-0.4-1.1 0.3-2.1 0.7-1.8 1.5z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m115.1 130.5c1.5-2 0.9-5-1.3-6.7-2.3-1.8-5.3-1.6-6.9 0.4-1.5 2-0.9 5 1.3 6.7 2.3 1.7 5.3 1.5 6.9-0.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m113 129c-0.2 0-0.3-0.1-0.3-0.3 0-0.9-0.5-1.8-1.3-2.3-0.6-0.5-1.4-0.6-2.1-0.3-0.1 0.1-0.3 0-0.4-0.2-0.1-0.2 0-0.3 0.2-0.4 0.8-0.4 1.9-0.2 2.7 0.3 0.9 0.7 1.5 1.7 1.5 2.9 0 0.2-0.1 0.3-0.3 0.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m67.1 152.2l-11.5 12.5 0.5 0.5 11.6-12.5z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m148.5 205.9l-0.3-0.7c8.5-2.5 16.6-5.6 24-14.9l0.6 0.5c-7.5 9.4-15.8 12.5-24.3 15.1z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m153.6 177.6h-71.5c-2.6 0-4.7 2.3-4.7 5v51.1c0 2.8 2.1 5 4.7 5h71.5c2.5 0 4.6-2.2 4.6-5v-51.1c0-2.7-2.1-5-4.6-5z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s8",
    d: "m123.6 205.5v5.4c0 1-0.9 1.9-2 1.9h-7.5c-1.1 0-2-0.9-2-1.9v-5.4c0-1.1 0.9-2 2-2h7.5c1.1 0 2 0.9 2 2zm-9.5-0.6c-0.3 0-0.5 0.3-0.5 0.6v5.4c0 0.2 0.2 0.5 0.5 0.5h7.5c0.3 0 0.5-0.3 0.5-0.5v-5.4c0-0.3-0.2-0.6-0.5-0.6z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m431 291.5h-431v1.4h431z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.fb6f1d2e47e653ecbf6c39f79c618b97.svg";
export { ForwardRef as ReactComponent };